import { isExperienceItem } from 'lib/checkout/checkoutUtils'
import { reselectShallowEqual } from 'lib/selector/selectorUtils'
import { createSelector } from 'reselect'

const getExperienceItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): Array<App.Checkout.ExperienceItem> => items.filter(isExperienceItem),
  reselectShallowEqual,
)

export default getExperienceItems
